import { css } from "@/domains/emotion";
import {
  MDSText,
  MDSTextColor,
  MDSTextOverflow,
  MDSTextVariant,
  MDSButton,
  MDSButtonVariant,
} from "@/mds";
import { mdsColors } from "@/design-system/foundations";
import { useGuestAppStore } from "@/store";
import styled from "@emotion/styled";
import { observer } from "mobx-react-lite";

export const GUEST_MODE_BANNER_HEIGHT = "40px";

export const GuestModeTopBanner = observer(() => {
  const { guestStore } = useGuestAppStore();
  return (
    <div className={containerStyles}>
      <StyledText
        variant={MDSTextVariant.TextS}
        overflow={MDSTextOverflow.Ellipsis}
        color={MDSTextColor.OnAccent}
      >
        Sign up to try all of Mem: The AI notes app that keeps you organized
      </StyledText>
      <StyledButton variant={MDSButtonVariant.OnAccent} onClick={guestStore.interface.openSignUpUi}>
        Sign up
      </StyledButton>
      <StyledButton variant={MDSButtonVariant.OnAccent} onClick={guestStore.interface.openSignUpUi}>
        Learn more
      </StyledButton>
    </div>
  );
});

const containerStyles = css({
  alignItems: "center",
  background: mdsColors().blue.x600,
  color: mdsColors().white,
  display: "flex",
  height: GUEST_MODE_BANNER_HEIGHT,
  justifyContent: "center",
  width: "100%",
});

const StyledText = styled(MDSText)`
  padding-right: 10px;
`;

const StyledButton = styled(MDSButton)`
  text-decoration: underline;
  border: none;
`;
